import { useState } from 'react';
import { Toast } from '../components/Toast/Toast';

type ToastSeverity = 'success' | 'error' | 'info' | 'warning';

interface UseToastReturn {
  showToast: (open: boolean, message?: string, severity?: ToastSeverity) => void;
  renderToast: () => JSX.Element;
}

export function useToast(): UseToastReturn {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastSeverity, setToastSeverity] = useState<ToastSeverity>('success');

  const showToast = (open: boolean, message?: string, severity?: ToastSeverity) => {
    setToastOpen(open);
    if (message !== undefined) {
      setToastMessage(message);
    }
    if (severity !== undefined) {
      setToastSeverity(severity);
    }
  };

  const renderToast = () => (
    <Toast 
      open={toastOpen}
      message={toastMessage}
      onClose={() => setToastOpen(false)}
      severity={toastSeverity}
    />
  );

  return {
    showToast,
    renderToast
  };
} 